import axios from "axios";

export default function SubscriptionAddService(formData) {

  return axios({
    method: 'post',
    url: process.env.REACT_APP_SUBSCRIPTION_API_HOST + "/subscription",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
